// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".expand-content[data-v-fb305968]{padding-left:16px;padding-right:16px}@media(min-width:950px){.expand-content[data-v-fb305968]{padding-left:40px;padding-right:40px}}.expand-content__title[data-v-fb305968]{width:170px}@media(max-width:767px){.expand-content__title[data-v-fb305968]{width:140px}}", ""]);
// Exports
module.exports = exports;
